import { CONFIG } from '../config';
import styles from './CtaSection.module.css';

export default function CtaSection() {
  const { cta } = CONFIG;
  return (
    <section className={styles.section}>
      <div className={styles.bg} />
      <span className={styles.glyph}>⚔️</span>
      <div className={styles.tag}>{cta.tag}</div>
      <h2 className={styles.title}>{cta.title}</h2>
      <p className={styles.desc}>{cta.desc}</p>
      <div className={styles.buttons}>
        <button className={styles.btnPrimary}>{cta.primaryBtn}</button>
        <button className={styles.btnOutline}>{cta.secondaryBtn}</button>
      </div>
    </section>
  );
}
